import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Row, Col, Button, Container } from "react-bootstrap";
import moment from 'moment';

import Loader from 'components/Loader'
import CartSummaryBox from "components/cart/CartSummaryBox"
import CreditCardForm from "components/cart/CreditCardForm"
import BankDepositForm from "components/cart/BankDepositForm"
import Timer from "components/Timer"

import { onError } from "libs/errorLib";
import { useCart } from "libs/cartLib"
import { useAuth } from "libs/authLib"
import { useAppContext } from "libs/contextLib";
import { LinkContainer } from "react-router-bootstrap";

export default function CartCheckout(props) {
    const { isGuestMode = false, ...otherProps } = props
    
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { getSession, updateUser, updateCartCounter } = useAppContext()
    const [user, setUser] = useState(null)
    const [cart, setCart] = useState(null)
    const [paymentType, setPaymentType] = useState('CREDIT_CARD')

    const { getCart, resetCart } = useCart()

    useEffect(() => {
        async function onLoad() {
            const session = await getSession()
            setUser(session?.user || null)

            let cart
            try {
                cart = await getCart()
                setCart(cart)
            } catch (e) {
                // no cart
            }
        }

        onLoad()
    }, [])

    async function handlePaymentSuccess(payment_info, purchase) {
        // Only save user data if not in guest mode and user exists
        if (!isGuestMode && payment_info.save_info && user) {
            const userInfo = {
                firstname: payment_info.firstname,
                lastname: payment_info.lastname,
                email: payment_info.email,
                phone: payment_info.phone,
                address: payment_info.address,
                city: payment_info.city,
                state: payment_info.state,
                country: payment_info.country,
                nit: payment_info.nit || "C/F",
            }

            await updateUser(user._id, userInfo)
        }

        await updateCartCounter()
        history.push(`/orders/${purchase.id}?new=1`)
    }

    function getCartSummary() {
        return <CartSummaryBox readOnly={true} totalsOnly={true} />
    }

    async function onTimerExpire() {
        await resetCart()
        history.push(`/cart/`)
    }

    function render() {
        const valid_thru = (cart && moment(cart.valid_thru)) || null
        if (moment().utc().isAfter(valid_thru))
            valid_thru = null;        

        return (
            <div className="content content-dark">
                <Container>
                    <Row><Col>
                        <h1 className="title">
                            {isGuestMode ? "Pagar Orden (Invitado)" : "Pagar Orden"}
                        </h1>
                        { valid_thru && (
                            <div className="timerBanner">
                                Tiempo de reserva: <Timer expiryTimestamp={valid_thru} autoStart={true} 
                                className="cartTimer" onExpire={onTimerExpire} />
                            </div>
                        )}
                        
                        {paymentType == 'CREDIT_CARD' && (
                            <CreditCardForm 
                                user={isGuestMode ? null : user} 
                                onSuccess={handlePaymentSuccess} 
                                cartSummary={getCartSummary}
                                allowGuestPurchase={true}
                                hideSaveData={isGuestMode} // Hide save data checkbox in guest mode
                            />
                        )}
                    </Col></Row>
                </Container>
            </div>
        )
    }

    return render()
}